import { render, staticRenderFns } from "./OtpConfigForm.vue?vue&type=template&id=5080b94f&scoped=true"
import script from "./OtpConfigForm.vue?vue&type=script&lang=js"
export * from "./OtpConfigForm.vue?vue&type=script&lang=js"
import style0 from "./OtpConfigForm.vue?vue&type=style&index=0&id=5080b94f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5080b94f",
  null
  
)

export default component.exports